import React from "react";
import { Link } from "react-router-dom";
import { CA_HD_2027_REPORT_PATH } from "../../config/publishedReports";

export default function CaHdForecastBanner({ className = "" }) {
  return (
    <div
      className={`border-t border-violet-200 bg-violet-50 ${className}`.trim()}
      role="region"
      aria-label="California heavy duty load forecast"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-center px-6 py-3.5 text-center lg:px-8">
        <p className="text-sm text-violet-900">
          Our 2027–2030 heavy-duty load forecast for California is now published. View it{" "}
          <Link
            to={CA_HD_2027_REPORT_PATH}
            className="font-semibold text-violet-800 underline underline-offset-2 hover:text-violet-950"
          >
            here
          </Link>
        </p>
      </div>
    </div>
  );
}
